import { useState } from 'react';

import type {
  ImagesItem,
  ImagesListClickEventHandler,
} from '@hotels-hotel-detail/ui/types';

import MediaGallery from '@hotels-hotel-detail/ui/MediaGallery';
import ReviewImagesList from '@hotels-hotel-detail/ui/ReviewImagesList';
import withScrimmedPortal from '@shared/ui/common/withScrimmedPortal';

const FullScreenMediaGallery = withScrimmedPortal(MediaGallery);

type Props = {
  images: ImagesItem[];
  showAllTravellerImages?: boolean;
  useSmallerImage?: boolean;
  reviewIndex?: number;
  onClick?: () => void;
};

const ReviewImageGallery = ({
  images,
  onClick,
  reviewIndex,
  showAllTravellerImages,
  useSmallerImage = false,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const openGallery: ImagesListClickEventHandler = (_event, imageIndex) => {
    setIsOpen(true);
    setStartIndex(imageIndex);
    onClick?.();
  };

  const closeGallery = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ReviewImagesList
        images={images}
        onClick={openGallery}
        showAllTravellerImages={showAllTravellerImages}
        useSmallerImage={useSmallerImage}
        reviewIndex={reviewIndex}
      />
      <FullScreenMediaGallery
        items={images}
        containerClassName="reviewGallery__container"
        isOpen={isOpen}
        startIndex={startIndex}
        onClose={closeGallery}
        showTravelInfo={false}
        showThumbnails={false}
        elementTrackingEventNames={{
          onCloseGallery: 'Review_Gallery_Close',
          onImageTransition: 'Review_Gallery_Transition',
        }}
      />
    </>
  );
};

export default ReviewImageGallery;
